"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeShift = exports.serializeShift = void 0;
const shift_1 = require("./shift");
// TODO should be moved to infrastructure layer
const serializeShift = (shift) => {
    return {
        id: shift.id,
        shift: {
            dayId: shift.date.id,
            price: {
                euro: shift.price.euro,
                cents: shift.price.cents,
            },
            childrenCanBePresent: shift.childrenCanAttend,
            crewCanBePresent: shift.crewCanAttend,
            kind: shift.presetName,
            tenant: shift.tenantId,
            description: shift.description,
            location: shift.location,
            startAndEnd: {
                start: {
                    hour: shift.startAndEnd.start.hour,
                    minute: shift.startAndEnd.start.minute,
                },
                end: {
                    hour: shift.startAndEnd.end.hour,
                    minute: shift.startAndEnd.end.minute,
                },
            },
        },
    };
};
exports.serializeShift = serializeShift;
// TODO should be moved to infrastructure layer
const deserializeShift = (shiftId, serialized) => {
    var _a, _b;
    const startMinutesSinceMidnight = serialized.startAndEnd.start.hour * 60 + serialized.startAndEnd.start.minute;
    const endMinutesSinceMidnight = serialized.startAndEnd.end.hour * 60 + serialized.startAndEnd.end.minute;
    return shift_1.Shift.fromProps({
        id: shiftId,
        dayId: serialized.dayId,
        childrenCanAttend: serialized.childrenCanBePresent,
        crewCanAttend: serialized.crewCanBePresent,
        description: (_a = serialized.description) !== null && _a !== void 0 ? _a : '',
        location: (_b = serialized.location) !== null && _b !== void 0 ? _b : '',
        priceCents: serialized.price.euro * 100 + serialized.price.cents,
        tenantId: serialized.tenant,
        presetName: serialized.kind,
        startMinutesSinceMidnight,
        endMinutesSinceMidnight,
    });
};
exports.deserializeShift = deserializeShift;
//# sourceMappingURL=shift.repository.js.map